<template>
  <CustomTabs :tab="tab" :data="tabs" @change_tab="onTabChange" alt paddingless>
    <template v-slot:default="{data}">
      <component
        :is="components[data.component]"
        :presetKitId="presetKitId"
        :key="data.name"
      />
    </template>
  </CustomTabs>
</template>

<script setup>
import CustomTabs from "@/components/common/CustomTabs";
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import PackageMaterialList from "./MaterialList.vue";
import ConstructivesList from "./ConstructivesList.vue";
import PackageTable from "./PackageTable.vue";

const props = defineProps({
  presetKitId: {
    type: Number,
    required: true
  },
  title: {
    type: String,
    default: 'Таблица пакета'
  }
})

const route = useRoute()
const router = useRouter()

const components = { PackageTable, PackageMaterialList, ConstructivesList }
const tabs = ref([
  {name: 'main', label: 'Основное', component: 'PackageTable'},
  {name: 'list', label: 'Список материалов', component: 'PackageMaterialList'}, 
  {name: 'constructives', label: 'Список конструктивов', component: 'ConstructivesList'}
])

const tab = ref(route.query.tab || 'main')

function onTabChange(value) {
  tab.value = value

  router.push({
    name: 'packageEntry',
    query: {
      presetKitId: props.presetKitId,
      tab: value
    }
  }).catch(() => {})
}
</script>

<style lang="scss" scoped></style>
